
import React from 'react';
import styles from './Testimonials.module.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faStar } from '@fortawesome/free-solid-svg-icons';
import discord_logo from '../assets/discord_logo.png';

const Testimonials = () => {
  const testimonials = [
    {
      text: "Consistent profit and top notch analysis, haven't had a negative week and very rarely have had a negative day, props to the team.",
      author: "liamstarrr"
    },
    {
      text: "The amount of information and guidance you have is insane for the price. Bro should be charging us more but they be blessing us fr.",
      author: "stevie.ngu"
    },
    {
      text: "Useful information, simple to understand, great price, quality bets, high win rates. Best thing I've invested into, this is the real deal.",
      author: "jadenky"
    },
    {
      text: "These guys are legit, walked me through my first couple weeks, they really know their stuff. Saw profits in my first few days would highly recommend to everyone",
      author: "rollytt"
    },
    {
      text: "Best community. Love the guys so welcoming and simple to pick up. Worth the money fs would recommend to all",
      author: "Dbraun11"
    },
    {
      text: "Gave this a crack after sitting on the fence for a while. Should've signed up sooner, great group, these guys don't miss it's crazy. Won my subscription fee back first day",
      author: "j.oakley"
    }
  ];

  const renderStars = () => {
    return [...Array(5)].map((_, index) => (
      <FontAwesomeIcon key={index} icon={faStar} className={styles.star} />
    ));
  };

  // Create multiple copies for seamless infinite scroll
  const allTestimonials = [...testimonials, ...testimonials, ...testimonials, ...testimonials, ...testimonials, ...testimonials, ...testimonials, ...testimonials, ...testimonials, ...testimonials, ...testimonials, ...testimonials];

  return (
    <section className={styles.testimonialsSection}>
      <h2 className={styles.title}>What Our Members Say</h2>
      <div className={styles.carouselContainer}>
        <div className={styles.carousel}>
          <div className={styles.carouselTrack}>
            {allTestimonials.map((testimonial, index) => (
              <div key={index} className={styles.testimonial}>
                <p className={styles.testimonialText}>{testimonial.text}</p>
                <div className={styles.testimonialFooter}>
                  <div className={styles.leftContent}>
                    <img src={discord_logo} alt="Discord" className={styles.discordIcon} />
                    <div className={styles.authorDetails}>
                      <div className={styles.testimonialAuthor}>{testimonial.author}</div>
                      <div className={styles.memberStatus}>Member</div>
                    </div>
                  </div>
                  <div className={styles.starRating}>{renderStars()}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
